function TermsAndConditionsPage() {
  return (
    <main className="bg-white py-8">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1
          className="text-4xl font-bold text-center mb-12 text-black"
          style={{ fontFamily: "Poppins, sans-serif" }}
        >
          Terms and Conditions
        </h1>

        <div className="prose prose-lg max-w-none text-gray-800">
          <h2 className="text-2xl font-bold mb-4 text-indigo-900">1. Introduction</h2>

          <p>
            These Terms and Conditions (“Terms”) govern your use of the services
            provided by <strong>Bay Area Conservatives PAC</strong> (“BAC PAC,”
            “we,” “our,” or “us”), and your use of our website (“Website”). By
            accessing our Website or engaging with our organization, you agree to
            these Terms in their entirety. Do not continue to use our Website if
            you do not agree to all Terms stated on this page.
          </p>

          <p>
            The following terminology applies to these Terms and Conditions,
            Privacy Statement, and all Agreements: “Visitor,” “You,” and “Your”
            refers to you, the person accessing this Website. “The PAC,”
            “Ourselves,” “We,” “Our,” and “Us” refers to BAC PAC. “Party,”
            “Parties,” or “Us” refers to both the Visitor and ourselves. All terms
            refer to the offer, acceptance, and consideration of payment necessary
            to undertake the process of our assistance to the Visitor in the most
            appropriate manner for the express purpose of meeting the PAC’s stated
            objectives, in accordance with and subject to the prevailing law of
            the State of Texas, United States.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">2. Website Use</h2>

          <h3 className="text-xl font-bold mb-2 text-gray-800">2.1 License to Use</h3>
          <p>
            Unless otherwise stated, BAC PAC and/or its licensors own the
            intellectual property rights for all material on the Website. All
            intellectual property rights are reserved. You may access content from
            our Website for your own personal use subject to the restrictions set
            in these Terms.
          </p>

          <p>You must not:</p>
          <ul className="list-disc pl-8 my-4">
            <li>Republish material from our Website</li>
            <li>Sell, rent, or sub-license material from our Website</li>
            <li>Reproduce, duplicate, or copy material from our Website</li>
            <li>Redistribute content from our Website</li>
            <li>Use data mining, robots, or similar data-gathering methods</li>
            <li>
              Circumvent, disable, or otherwise interfere with security features
              of the Website
            </li>
          </ul>

          <h3 className="text-xl font-bold mb-2 text-gray-800 mt-6">2.2 User Comments</h3>
          <p>
            Parts of this Website may offer an opportunity for users to post and
            exchange opinions and information. BAC PAC does not filter, edit,
            publish, or review Comments prior to their presence on the Website.
            Comments do not necessarily reflect the views and opinions of BAC PAC,
            its agents, or affiliates.
          </p>

          <p>
            BAC PAC reserves the right to monitor all Comments and to remove any
            Comments that can be considered inappropriate, offensive, or cause a
            breach of these Terms.
          </p>

          <p>You warrant and represent that:</p>
          <ul className="list-disc pl-8 my-4">
            <li>You are entitled to post Comments on our Website</li>
            <li>
              Comments do not invade any intellectual property rights of any third
              party
            </li>
            <li>
              Comments do not contain defamatory, libelous, offensive, or unlawful
              material
            </li>
            <li>
              Comments will not be used to solicit or promote business or unlawful
              activity
            </li>
          </ul>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">3. Donations</h2>

          <p>
            When you make a donation to BAC PAC, you agree to provide accurate and
            complete payment information. All donations are final and
            non-refundable. BAC PAC reserves the right to refuse or return any
            donation that it believes may violate any law or regulation.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">4. Privacy</h2>
          <p>
            Your privacy is important to us. Our Privacy Policy, which is
            incorporated into these Terms by reference, explains how we collect,
            use, and disclose information about you.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">
            5. Disclaimer of Warranties
          </h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE WEBSITE AND
            SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE,” WITHOUT WARRANTIES OF
            ANY KIND, EITHER EXPRESS OR IMPLIED.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">
            6. Limitation of Liability
          </h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, BAC PAC WILL NOT BE
            LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
            PUNITIVE DAMAGES.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">7. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the
            laws of the State of Texas, specifically Harris and Galveston
            Counties, without regard to its conflict-of-law provisions. Any
            disputes shall be resolved exclusively in those courts, and you agree
            to submit to their jurisdiction.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">8. Modifications</h2>
          <p>
            We reserve the right to modify these Terms at any time. Changes will
            be effective upon posting to our Website. Your continued use of our
            Website after such changes constitutes acceptance of the modified
            Terms.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">9. Contact Us</h2>

          <div className="my-4">
            <p>Bay Area Conservatives PAC</p>
            <p>Clear Lake & Galveston Bay Area, TX</p>
            <p>
              Email:&nbsp;
              <a
                href="mailto:info@bayareaconservativepac.org"
                className="text-indigo-700 hover:text-indigo-900"
              >
                info@bayareaconservativepac.org
              </a>
            </p>
          </div>

          <p className="mt-12 text-gray-600 text-center">
            <strong>Last Updated: April 29, 2025</strong>
          </p>
        </div>
      </div>
    </main>
  );
}

export default TermsAndConditionsPage;
